import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

const portfolioItems = [
  {
    id: 1,
    title: 'Location Intelligence Dashboard',
    category: 'Analytics',
    image: '/portfolio/dashboard-1024x808.png',
    description: 'Interactive dashboard for real-time geospatial data visualization'
  },
  {
    id: 2,
    title: 'Amenity Mapper',
    category: 'Web Mapping',
    image: '/portfolio/amenity-mapper-1024x467.png',
    description: 'Custom amenity mapping solution for urban planning'
  },
  {
    id: 3,
    title: 'Site Selection Analysis',
    category: 'Analytics',
    image: '/portfolio/best-place-to-open-salon-Orlando.png',
    description: 'Data-driven site selection for business optimization'
  },
  {
    id: 4,
    title: 'California Organ Donor Map',
    category: 'Web Mapping',
    image: '/portfolio/ca-donor-map.gif',
    description: 'Interactive map showing organ donor registration by county'
  },
  {
    id: 5,
    title: 'Lake Ozark Recreation Map',
    category: 'Web Mapping',
    image: '/portfolio/lake-ozarks.gif',
    description: 'Interactive map of recreational locations around Lake of the Ozarks'
  },
  {
    id: 6,
    title: 'Multi-Location Service Area',
    category: 'Web Mapping',
    image: '/portfolio/service-area.gif',
    description: 'Dynamic service coverage mapping for multi-site operations'
  },
  {
    id: 7,
    title: 'Proximity Analysis Tool',
    category: 'Web Mapping',
    image: '/portfolio/HotelsNearDCMetro.png',
    description: 'Multi-criteria proximity analysis for location planning'
  },
  {
    id: 8,
    title: 'Real Estate Market Analysis',
    category: 'Analytics',
    image: '/portfolio/Ironbridge-Real-Estate.png',
    description: 'Comprehensive real estate market intelligence platform'
  },
  {
    id: 9,
    title: 'Service Area Mapping',
    category: 'Web Mapping',
    image: '/portfolio/Radius-Map-3.png',
    description: 'Dynamic service area visualization and optimization'
  },
  {
    id: 10,
    title: 'Data Visualization Platform',
    category: 'Analytics',
    image: '/portfolio/datadash.gif',
    description: 'Real-time data visualization and monitoring system'
  },
  {
    id: 11,
    title: 'Demographics Mapping',
    category: 'Analytics',
    image: '/portfolio/Experian-Zipcode-map-862x1024.jpg',
    description: 'Demographic analysis and visualization tools'
  },
  {
    id: 12,
    title: 'Interactive Story Map',
    category: 'Story Maps',
    image: '/portfolio/storymap2.gif',
    description: 'Engaging narrative-driven geospatial presentations'
  },
  {
    id: 13,
    title: 'Walkability Analysis',
    category: 'Analytics',
    image: '/portfolio/amenity-walk-1.jpg',
    description: 'Comprehensive walkability assessment tool'
  },
  {
    id: 14,
    title: 'Service Territory Planner',
    category: 'Web Mapping',
    image: '/portfolio/dry-cleaning-1024x527.png',
    description: 'Territory planning and optimization solution'
  },
  {
    id: 15,
    title: 'Spatial Analysis Dashboard',
    category: 'Analytics',
    image: '/portfolio/analysis1_a.png',
    description: 'Advanced spatial analysis and modeling platform'
  }
];

const PortfolioGrid = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Analytics', 'Web Mapping', 'Story Maps'];

  const filteredItems = filter === 'All' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === filter);

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Our Work
          </h2>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                filter === category
                  ? 'bg-[#33C7A9] text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map(item => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <p className="text-white text-sm opacity-90">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 text-xs font-semibold text-[#33C7A9] bg-[#33C7A9]/10 rounded-full mb-3">
                  {item.category}
                </span>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#6A7EC9] transition-colors duration-300">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioGrid;